import { render, staticRenderFns } from "./RelateNumberSie.vue?vue&type=template&id=747223b0&scoped=true"
import script from "./RelateNumberSie.vue?vue&type=script&lang=js"
export * from "./RelateNumberSie.vue?vue&type=script&lang=js"
import style0 from "./RelateNumberSie.vue?vue&type=style&index=0&id=747223b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747223b0",
  null
  
)

export default component.exports